angular.module('env.data.models.categoryTypeModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("CategoryTypeModel",
            {
                extend: ['BaseModel'],
                url: "categorytype",
                fields: {
                    code: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    name: {
                        type: RepresentationModelFieldTypes.STRING
                    }
                }
            }
        );
    })

;